import React, { useState } from "react";
import ReactDOM from "react-dom";

export const Confirm = ({
    layer = true,
    onClose,
    title,
    description,
    buttons = [],
    showCheckbox = false,
    checkboxLabel = "메시지 다시 띄우지 않기",
}) => {
    const [dontShowAgain, setDontShowAgain] = useState(false);

    const handleButtonClick = (button) => {
        if (button.onClick) {
            button.onClick({ dontShowAgain });
        }
        if (button.closeOnClick !== false) {
            onClose();
        }
    };

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>

            <div className="popup confirm-popup">
                <div className="popup-content">
                    <div className="content-title">
                        <span>{title}</span>
                    </div>
                    <div className="content-description">
                        <p>{description}</p>
                    </div>
                    {showCheckbox && (
                        <div className="checkbox-group" style={{ marginTop: "10px" }}>
                            <div className="checkbox">
                                <input
                                    type="checkbox"
                                    id="dontShowAgain"
                                    checked={dontShowAgain}
                                    onChange={(e) => setDontShowAgain(e.target.checked)}
                                />
                                <label htmlFor="dontShowAgain">
                                    <span>{checkboxLabel}</span>
                                </label>
                            </div>
                        </div>
                    )}
                </div>
                <div className="popup-bottom">
                    {buttons.map((button, index) => (
                        <button key={index} className={`btn ${button.className}`} onClick={() => handleButtonClick(button)}>
                            {button.label}
                        </button>
                    ))}
                </div>
            </div>
        </>,
        document.body
    );
};
